import {simpleAction} from "utils/stateUtils";
import {payloadAction} from "utils/stateUtils";

export const NOTIFICATIONS_SET_PROPS = 'NOTIFICATIONS_SET_PROPS';
export const NOTIFICATIONS_INIT_PUSH = 'NOTIFICATIONS_INIT_PUSH';

export const setNotificationsProps = payloadAction(NOTIFICATIONS_SET_PROPS);
export const initPush = simpleAction(NOTIFICATIONS_INIT_PUSH);
